export default __webpack_public_path__ + "static/media/img_baseCottonBunny_flowers.602376e3.jpg";